/**
 * User Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines user management routes (admin-only).
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const UsersPage = lazy(() => import('@/features/users/ui/pages/users-page'));
const UserDetailPage = lazy(() => import('@/features/users/ui/pages/user-detail-page'));

export const userRoutes: RouteGroup = {
  name: 'users',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: false,
    allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
  },
  routes: [
    {
      path: ROUTE_PATHS.USERS,
      component: UsersPage,
      meta: {
        title: 'users:page.title',
        icon: 'UserGroupIcon',
        showInNav: true,
        navOrder: 7,
      },
    },
    {
      path: ROUTE_PATHS.USER_DETAIL,
      component: UserDetailPage,
      meta: {
        title: 'users:detail.title',
        parent: ROUTE_PATHS.USERS,
      },
    },
  ],
};
